import React, { useState } from "react";

export default function FunctionalTestingQuiz() {

  const questions = [
    {
      question: "Functional testing focuses primarily on:",
      options: [
        "Internal program structure",
        "Functional requirements of the software",
        "Code efficiency",
        "Programming language syntax"
      ],
      answer: 1,
      explanation: "Functional testing evaluates software behavior against its specified functional requirements."
    },
    {
      question: "Functional testing is also known as:",
      options: [
        "White-box testing",
        "Black-box testing",
        "Structural testing",
        "Path testing"
      ],
      answer: 1,
      explanation: "Functional testing is commonly called black-box testing because the internal code is not considered."
    },
    {
      question: "Which of the following is NOT a typical error detected by functional testing?",
      options: [
        "Missing functions",
        "Interface errors",
        "Compiler syntax errors",
        "Initialization errors"
      ],
      answer: 2,
      explanation: "Compiler syntax errors occur during development, not during functional testing."
    },
    {
      question: "Equivalence partitioning divides input data into:",
      options: [
        "Independent execution paths",
        "Equivalent classes of data",
        "Memory blocks",
        "Algorithm steps"
      ],
      answer: 1,
      explanation: "Equivalence partitioning groups inputs into classes expected to behave similarly."
    },
    {
      question: "Boundary Value Analysis focuses on:",
      options: [
        "Middle input values",
        "Random values",
        "Edge values of input ranges",
        "Internal code paths"
      ],
      answer: 2,
      explanation: "Boundary value analysis tests the edges of input ranges where defects commonly occur."
    },
    {
      question: "Which method uses logical relationships between inputs and outputs to design tests?",
      options: [
        "Cause-effect graphing",
        "Loop testing",
        "Path testing",
        "Mutation testing"
      ],
      answer: 0,
      explanation: "Cause-effect graphing maps logical relationships between conditions and actions."
    },
    {
      question: "Decision tables are used to:",
      options: [
        "Test loops",
        "Represent complex business rules",
        "Analyze memory usage",
        "Optimize algorithms"
      ],
      answer: 1,
      explanation: "Decision tables help represent complex combinations of conditions and actions."
    },
    {
      question: "Boundary errors most often occur:",
      options: [
        "In the middle of input ranges",
        "At the edges of input domains",
        "Inside loops",
        "During compilation"
      ],
      answer: 1,
      explanation: "Many defects occur at boundary values like minimum and maximum limits."
    },
    {
      question: "Functional testing evaluates the system based on:",
      options: [
        "Implementation code",
        "Specification behavior",
        "Hardware configuration",
        "Developer preference"
      ],
      answer: 1,
      explanation: "Functional tests validate behavior against specifications."
    },
    {
      question: "The main goal of functional testing is to:",
      options: [
        "Improve algorithm speed",
        "Verify software functions match requirements",
        "Rewrite code",
        "Reduce memory usage"
      ],
      answer: 1,
      explanation: "Functional testing ensures that the system behaves according to its defined requirements."
    }
  ];

  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);
  const [finished, setFinished] = useState(false);

  const handleSelect = (index) => {
    if (showAnswer) return;

    setSelected(index);
    setShowAnswer(true);

    if (index === questions[current].answer) {
      setScore(score + 1);
    }
  };

  const nextQuestion = () => {
    setSelected(null);
    setShowAnswer(false);

    if (current + 1 < questions.length) {
      setCurrent(current + 1);
    } else {
      setFinished(true);
    }
  };

  const restartQuiz = () => {
    setCurrent(0);
    setScore(0);
    setSelected(null);
    setShowAnswer(false);
    setFinished(false);
  };

  if (finished) {
    return (
      <div className='' style={{ padding: 40, textAlign: "center" }}>
        <h1>Quiz Complete</h1>
        <h2>
          Score: {score} / {questions.length}
        </h2>

        <button
          onClick={restartQuiz}
          style={{
            marginTop: 20,
            padding: "10px 20px",
            fontSize: 16,
            cursor: "pointer"
          }}
        >
          Restart Quiz
        </button>
      </div>
    );
  }

  const q = questions[current];

  return (
    <div style={{ maxWidth: 700, margin: "auto", padding: 30 }}>
      <h2>
        Question {current + 1} / {questions.length}
      </h2>

      <h3 style={{ marginBottom: 20 }}>{q.question}</h3>

      {q.options.map((opt, i) => {
        let background = "#eee";

        if (showAnswer) {
          if (i === q.answer) background = "#9ae6b4";
          else if (i === selected) background = "#feb2b2";
        }

        return (
          <div
          className='text-black'
            key={i}
            onClick={() => handleSelect(i)}
            style={{
              padding: 12,
              marginBottom: 10,
              borderRadius: 8,
              cursor: "pointer",
              background
            }}
          >
            {opt}
          </div>
        );
      })}

      {showAnswer && (
        <div style={{ marginTop: 20 }}>
          <p>
            <strong>Explanation:</strong> {q.explanation}
          </p>

          <button
            onClick={nextQuestion}
            style={{
              marginTop: 10,
              padding: "8px 16px",
              cursor: "pointer"
            }}
          >
            Next Question
          </button>
        </div>
      )}

      <div style={{ marginTop: 30 }}>
        Score: {score}
      </div>
    </div>
  );
}
